<template>
  <div class="category-navigation">
    <div class="category-navigation__inner" v-if="navData">
      <!-- Featured Resource -->
      <div ref="matomoSectionCompanyIntro" class="featured-section">
        <button
          v-for="(resource, fIdx) in navData.featuredResources"
          :key="resource.id"
          class="featured-card"
          @click="onFeaturedCardClick(resource, fIdx)"
          @mouseenter="hoveredId = resource.id"
          @mouseleave="hoveredId = null"
        >
          <div class="featured-card__content">
            <h3 class="featured-card__title">{{ resource.title }}</h3>
            <p class="featured-card__desc">
              {{ hoveredId === resource.id ? resource.description : resource.title }}
            </p>
          </div>
          <i class="el-icon-right featured-card__arrow" />
        </button>
      </div>

      <!-- Two Column Grid -->
      <div class="grid-two">
        <!-- Sangfor Cloud -->
        <div
          ref="matomoSectionCloud"
          class="card-module"
          :class="{ 'card-module--hover': hoveredId === 'cloud-module' }"
          @mouseenter="hoveredId = 'cloud-module'"
          @mouseleave="hoveredId = null"
        >
          <div class="card-module__header">
            <h3 class="card-module__title">{{ navData.cloudModule.title }}</h3>
            <p class="card-module__subtitle">{{ navData.cloudModule.subtitle }}</p>
          </div>

          <div class="card-module__body">
            <button
              v-if="navData.cloudModule.introButton"
              class="btn-intro"
              :type="navData.cloudModule.introButton.showModal ? 'button' : 'button'"
              @click="onCloudIntroClick"
            >
              <span>{{ navData.cloudModule.introButton.text }}</span>
              <i class="el-icon-right" />
            </button>

            <!-- Cloud Products -->
            <div class="accordion" v-if="navData.cloudModule.cloudProducts">
              <div class="accordion__header" @click="toggleSection('cloudProducts')">
                <span class="accordion1__title">{{ navData.cloudModule.cloudProducts.title }}</span>
                <i :class="[expandedSections.cloudProducts ? 'el-icon-arrow-up' : 'el-icon-arrow-down', 'accordion__arrow']" />
              </div>
              <div v-if="expandedSections.cloudProducts" class="accordion__body">
                <div :class="['button-grid', 'button-grid--' + (navData.cloudModule.cloudProducts.gridCols || 2)]">
                  <button
                    v-for="(item, pIdx) in navData.cloudModule.cloudProducts.items"
                    :key="item.id"
                    :disabled="item.disabled"
                    :class="getButtonClass(item)"
                    @click="onProductButtonClick(item, navData.cloudModule.cloudProducts.title, pIdx, navData.cloudModule.cloudProducts.gridCols || 2)"
                    @mouseenter="onProductButtonHover($event, item, 'product',navData.cloudModule.cloudProducts)"
                    @mouseleave="onProductButtonLeave(item)"
                  >
                    {{ item.name }}
                  </button>
                </div>
              </div>
              <p v-else class="accordion__summary">{{ navData.cloudModule.cloudProducts.summary }}</p>
            </div>

            <!-- Cloud Solutions -->
            <div class="accordion" v-if="navData.cloudModule.cloudSolutions">
              <div class="accordion__header" @click="toggleSection('cloudSolutions')">
                <span class="accordion1__title">{{ navData.cloudModule.cloudSolutions.title }}</span>
                <i :class="[expandedSections.cloudSolutions ? 'el-icon-arrow-up' : 'el-icon-arrow-down', 'accordion__arrow']" />
              </div>
              <div v-if="expandedSections.cloudSolutions" class="accordion__body">
                <div :class="['button-grid', 'button-grid--' + (navData.cloudModule.cloudSolutions.gridCols || 1)]">
                  <button
                    v-for="(item, sIdx) in navData.cloudModule.cloudSolutions.items"
                    :key="item.id"
                    :disabled="item.disabled"
                    :class="getButtonClass(item)"
                    @click="onProductButtonClick(item, navData.cloudModule.cloudSolutions.title, sIdx, navData.cloudModule.cloudSolutions.gridCols || 1)"
                    @mouseenter="onProductButtonHover($event, item, 'solution',navData.cloudModule.cloudSolutions)"
                    @mouseleave="onProductButtonLeave(item)"
                  >
                    {{ item.name }}
                  </button>
                </div>
              </div>
              <p v-else class="accordion__summary">{{ navData.cloudModule.cloudSolutions.summary }}</p>
            </div>

          </div>
        </div>

        <!-- Sangfor Athena -->
        <div
          ref="matomoSectionAthena"
          class="card-module"
          :class="{ 'card-module--hover': hoveredId === 'athena-module' }"
          @mouseenter="hoveredId = 'athena-module'"
          @mouseleave="hoveredId = null"
        >
          <div class="card-module__header">
            <h3 class="card-module__title">{{ navData.athenaModule.title }}</h3>
            <p class="card-module__subtitle">{{ navData.athenaModule.subtitle }}</p>
          </div>

          <div class="card-module__body">
            <button
              v-if="navData.athenaModule.introButton"
              class="btn-intro"
              type="button"
              @click="onAthenaIntroClick"
            >
              <span>{{ navData.athenaModule.introButton.text }}</span>
              <i class="el-icon-right" />
            </button>

            <!-- Athena Products -->
            <div class="accordion" v-if="navData.athenaModule.athenaProducts">
              <div class="accordion__header" @click="toggleSection('athenaProducts')">
                <span class="accordion__title accordion__title--clickable" @click.stop="openImageModal('athenaProducts', navData.athenaModule.athenaProducts.title)">{{ navData.athenaModule.athenaProducts.title }}</span>
                <i :class="[expandedSections.athenaProducts ? 'el-icon-arrow-up' : 'el-icon-arrow-down', 'accordion__arrow']" />
              </div>
              <div v-if="expandedSections.athenaProducts" class="accordion__body">
                <div class="athena-products">
                  <div
                    v-for="group in navData.athenaModule.athenaProducts.groups"
                    :key="group.title"
                    class="athena-group"
                  >
                    <h4 class="athena-group__title">{{ group.title }}</h4>
                    <div :class="['button-grid', 'button-grid--' + (group.gridCols || 2)]">
                      <!-- 原逻辑：disabled 仍渲染为 button + btn-product--disabled
                      <button
                        v-for="(item, gIdx) in group.items"
                        :key="item.id"
                        :disabled="item.disabled"
                        :class="getButtonClass(item)"
                        @click="onProductButtonClick(item, group.title, gIdx, group.gridCols || 2)"
                        @mouseenter="onProductButtonHover($event, item, 'product',group)"
                        @mouseleave="onProductButtonLeave(item)"
                      >
                        {{ item.name }}
                      </button>
                      -->
                      <template v-for="(item, gIdx) in group.items">
                        <div v-if="item.disabled" :key="item.id" class="btn-disabled">{{ item.name }}</div>
                        <button
                          v-else
                          :key="item.id"
                          :class="getButtonClass(item)"
                          @click="onProductButtonClick(item, group.title, gIdx, group.gridCols || 2)"
                          @mouseenter="onProductButtonHover($event, item, 'product', group)"
                          @mouseleave="onProductButtonLeave(item)"
                        >
                          {{ item.name }}
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <p v-else class="accordion__summary">{{ navData.athenaModule.athenaProducts.summary }}</p>
            </div>

            <!-- Athena Solutions -->
            <div class="accordion" v-if="navData.athenaModule.athenaSolutions">
              <div class="accordion__header" @click="toggleSection('athenaSolutions')">
                <span class="accordion__title accordion__title--clickable" @click.stop="openImageModal('athenaSolutions', navData.athenaModule.athenaSolutions.title)">{{ navData.athenaModule.athenaSolutions.title }}</span>
                <i :class="[expandedSections.athenaSolutions ? 'el-icon-arrow-up' : 'el-icon-arrow-down', 'accordion__arrow']" />
              </div>
              <div v-if="expandedSections.athenaSolutions" class="accordion__body">
                <div :class="['button-grid', 'button-grid--' + (navData.athenaModule.athenaSolutions.gridCols || 1)]">
                  <button
                    v-for="(item, aIdx) in navData.athenaModule.athenaSolutions.items"
                    :key="item.id"
                    :disabled="item.disabled"
                    :class="getButtonClass(item)"
                    @click="onProductButtonClick(item, navData.athenaModule.athenaSolutions.title, aIdx, navData.athenaModule.athenaSolutions.gridCols || 1)"
                    @mouseenter="onProductButtonHover($event, item, 'solution',navData.athenaModule.athenaSolutions)"
                    @mouseleave="onProductButtonLeave(item)"
                  >
                    {{ item.name }}
                  </button>
                </div>
              </div>
              <p v-else class="accordion__summary">{{ navData.athenaModule.athenaSolutions.summary }}</p>
            </div>

            <!-- Additional Athena Sections -->
            <div class="additional-sections" v-if="navData.athenaModule.additionalSections">
              <div
                v-for="(item, addIdx) in navData.athenaModule.additionalSections"
                :key="item.id"
                class="additional-sections__item"
              >
                <div v-if="item.disabled" class="btn-disabled">{{ item.name }}</div>
                <button
                  v-else
                  :class="['btn-full', { 'btn-full--active': hoveredId === item.id }]"
                  type="button"
                  @click="onAdditionalSectionClick(item, addIdx)"
                  @mouseenter="hoveredId = item.id"
                  @mouseleave="hoveredId = null"
                >
                  {{ item.name }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom Buttons -->
      <div
        ref="matomoSectionTraining"
        class="bottom-buttons"
        v-if="navData.bottomButtons && navData.bottomButtons.length"
      >
        <button
          v-for="(btn, bIdx) in navData.bottomButtons"
          :key="btn.id"
          class="btn-gradient"
          type="button"
          @click="onBottomButtonClick(btn, bIdx)"
        >
          {{ btn.text }}
        </button>
      </div>

      <!-- Product Menu (floating) -->
      <ProductMenu
        :menu-options="productMenuState.menuOptions"
        :option-links="productMenuState.optionLinks"
        :product-name="productMenuState.productName"
        :is-open="productMenuState.isOpen"
        :position="productMenuState.position"
        @mouseenter="cancelMenuCloseTimer"
        @mouseleave="productMenuState = { ...productMenuState, isOpen: false }"
        @select="handleMenuSelect"
      />

      <!-- 图片弹窗（Cloud / Athena Products / Athena Solutions 共用） -->
      <ImageModal
        :is-open="!!imageModalState.type"
        :image-src="imageModalState.imageSrc"
        :image-alt="imageModalState.imageAlt"
        :download-filename="imageModalState.downloadFilename"
        @close="imageModalState = { type: null }"
      />
    </div>
    
  </div>
</template>

<script>
import ProductMenu from './ProductMenu.vue';
import ImageModal from './ImageModal.vue';
import { getCategoryNavigationData } from '@/api/common';
import {
  markHomePageEngaged,
  trackCategorySectionExposure,
  trackCategoryCardClick,
  trackDocumentClick,
  formatCardGridPosition,
  parseArticleIdFromKbLink
} from '@/utils/matomoTracking.js';
// 默认数据（打包时注入），public/category-navigation.json 可覆盖
import defaultNavData from '@/data/category-navigation.json';
// 嵌入图片（存放在 src/assets/img，可随项目提交 git）
import cloudIntroImage from '@/assets/img/cloud-introduction.svg';
import athenaProductsImage from '@/assets/img/athena-products.png';
import athenaSolutionsImage from '@/assets/img/athena-solutions.png';

export default {
  name: 'CategoryNavigation',
  components: { ProductMenu, ImageModal },
  data() {
    return {
      cloudIntroImage,
      navDataTitle:'',
      athenaProductsImage,
      athenaSolutionsImage,
      navData: (defaultNavData && defaultNavData.default) ? defaultNavData.default : (defaultNavData || {}),
      loading: false,
      hoveredId: null,
      expandedSections: {
        cloudProducts: true,
        cloudSolutions: true,
        athenaProducts: true,
        athenaSolutions: true
      },
      imageModalState: { type: null, imageSrc: '', imageAlt: '', downloadFilename: '' },
      productMenuState: {
        isOpen: false,
        productName: '',
        productId: '',
        menuType: 'product',
        menuOptions: [],
        optionLinks: {},
        position: { top: 0, left: 0, width: 0 }
      },
      menuCloseTimer: null,
      matomoSectionObserved: {},
      matomoObserverAttached: {}
    };
  },
  mounted() {
    this.preloadModalImages();
    this.loadNavData();
    this.$nextTick(() => this.setupMatomoSectionObservers());
  },
  methods: {
    setupMatomoSectionObservers() {
      if (typeof IntersectionObserver === 'undefined') return;
      const map = [
        { ref: 'matomoSectionCompanyIntro', section: 'company_intro' },
        { ref: 'matomoSectionCloud', section: 'cloud_security' },
        { ref: 'matomoSectionAthena', section: 'products_solutions' },
        { ref: 'matomoSectionTraining', section: 'training_materials' }
      ];
      map.forEach(({ ref, section }) => {
        if (this.matomoSectionObserved[section] || this.matomoObserverAttached[section]) return;
        const el = this.$refs[ref];
        if (!el) return;
        this.matomoObserverAttached[section] = true;
        const io = new IntersectionObserver(
          (entries) => {
            if (entries[0] && entries[0].isIntersecting && !this.matomoSectionObserved[section]) {
              this.matomoSectionObserved[section] = true;
              trackCategorySectionExposure(section);
              io.disconnect();
            }
          },
          { threshold: 0.15 }
        );
        io.observe(el);
      });
    },
    onFeaturedCardClick(resource, index) {
      markHomePageEngaged();
      trackCategoryCardClick('Company Profile', resource.title, formatCardGridPosition(index, 1));
      const aid = parseArticleIdFromKbLink(resource.link);
      if (aid) {
        trackDocumentClick(aid, resource.title, 'homepage_recommend');
      }
      if (resource.link) {
        this.navigateTo(resource.link);
      }
    },
    onCloudIntroClick() {
      const intro = this.navData.cloudModule && this.navData.cloudModule.introButton;
      if (!intro) return;
      markHomePageEngaged();
      trackCategoryCardClick('Sangfor Cloud', intro.text, '第1行第1列');
      if (intro.showModal) {
        this.openImageModal('cloud');
      }
    },
    onAthenaIntroClick() {
      const intro = this.navData.athenaModule && this.navData.athenaModule.introButton;
      if (!intro || !intro.link) return;
      markHomePageEngaged();
      trackCategoryCardClick('Sangfor Athena', intro.text, '第1行第1列');
      this.navigateTo(intro.link);
    },
    onBottomButtonClick(btn, index) {
      markHomePageEngaged();
      trackCategoryCardClick('Training Materials', btn.text, formatCardGridPosition(index, 1));
      if (btn.link) {
        this.navigateTo(btn.link);
      }
    },
    onAdditionalSectionClick(item, index) {
      if (!item.link) return;
      markHomePageEngaged();
      trackCategoryCardClick('Additional sections', item.name, formatCardGridPosition(index, 1));
      this.navigateTo(item.link);
    },
    preloadModalImages() {
      [this.cloudIntroImage, this.athenaProductsImage, this.athenaSolutionsImage].forEach(src => {
        if (src) {
          const img = new Image();
          img.src = src;
        }
      });
    },
    async loadNavData() {
      // 直接使用 import 的默认数据，接口仅作可选覆盖
      try {
        const res = await Promise.race([
          getCategoryNavigationData(),
          new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 3000))
        ]);
        const data = res.data || res;

        if (data && (data.cloudModule || data.featuredResources)) {
          this.navData = JSON.parse(JSON.stringify(data));
          this.$nextTick(() => this.setupMatomoSectionObservers());
        }
      } catch (e) {
        // 请求失败或超时，保留默认数据
      }
    },
    toggleSection(section) {
      this.expandedSections[section] = !this.expandedSections[section];
    },
    onProductButtonHover(event, item, menuType,navData) {
     this.navDataTitle = navData.title;
      if (item.disabled) return;
      if (this.menuCloseTimer) {
        clearTimeout(this.menuCloseTimer);
        this.menuCloseTimer = null;
      }
      this.hoveredId = item.id;
      const rect = event.currentTarget.getBoundingClientRect();
      const row = event.currentTarget.closest('.button-grid');
      const rowRect = row ? row.getBoundingClientRect() : null;
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const padding = Math.max(12, Math.min(24, vw * 0.02));
      const gap = 2;
      const maxMenuWidth = vw >= 1280 ? Math.min(160, Math.max(100, vw * 0.1)) : Math.min(100, Math.max(80, vw * 0.12));
      const width = maxMenuWidth;
      const btnCenterX = rect.left + rect.width / 2;
      const rowCenterX = rowRect ? rowRect.left + rowRect.width / 2 : null;
      const isRightSide = rowCenterX !== null && btnCenterX > rowCenterX;
      let left;
      if (isRightSide) {
        left = rect.right + gap;
        if (left + width > vw - padding) left = vw - width - padding;
      } else {
        left = rect.left - width - gap;
        left = Math.max(padding, Math.min(left, vw - width - padding));
      }
      let top = rect.top;
      const menuHeightEstimate = 220;
      if (top + menuHeightEstimate > vh - padding) top = vh - menuHeightEstimate - padding;
      if (top < padding) top = padding;
      const linksMap = menuType === 'product' ? this.navData.productMenuLinks : this.navData.solutionMenuLinks;
      const itemLinks = linksMap && linksMap[item.id];
      const hasMenuLinks = !!itemLinks;
      const menuOptions = menuType === 'product'
        ? (this.navData.productMenuOptions || [])
        : (this.navData.solutionMenuOptions || []);
      this.productMenuState = {
        isOpen: !!hasMenuLinks,
        productName: item.name,
        productId: item.id,
        menuType,
        menuOptions: hasMenuLinks ? menuOptions : [],
        optionLinks: itemLinks || {},
        position: {
          top,
          left,
          width
        }
      };
    },
    onProductButtonLeave(item) {
      this.hoveredId = null;
      // this.navDataTitle = '';
      const productId = item.id;
      this.menuCloseTimer = setTimeout(() => {
        if (this.productMenuState.productId === productId) {
          this.productMenuState = { ...this.productMenuState, isOpen: false };
        }
        this.menuCloseTimer = null;
      }, 150);
    },
    cancelMenuCloseTimer() {
      if (this.menuCloseTimer) {
        clearTimeout(this.menuCloseTimer);
        this.menuCloseTimer = null;
      }
    },
    openImageModal(type, accordionTitle) {
      if (accordionTitle) {
        markHomePageEngaged();
        trackCategoryCardClick(accordionTitle || 'Accordion', 'Overview image', '标题');
      }
      const configs = {
        cloud: {
          type: 'cloud',
          imageSrc: (this.navData.cloudIntroModal && this.navData.cloudIntroModal.imageSrc) || this.cloudIntroImage,
          imageAlt: (this.navData.cloudIntroModal && this.navData.cloudIntroModal.imageAlt) || 'Sangfor Mission & Vision in AI Cloud Era',
          downloadFilename: 'cloud-introduction.svg'
        },
        athenaProducts: {
          type: 'athenaProducts',
          imageSrc: this.athenaProductsImage,
          imageAlt: 'Athena Products',
          downloadFilename: 'athena-products.png'
        },
        athenaSolutions: {
          type: 'athenaSolutions',
          imageSrc: this.athenaSolutionsImage,
          imageAlt: 'Athena Solutions',
          downloadFilename: 'athena-solutions.png'
        }
      };
      this.imageModalState = configs[type] || { type: null };
    },
    onProductButtonClick(item, parentCategory, index, gridCols) {
      if (item.disabled || !item.link) return;
      markHomePageEngaged();
      trackCategoryCardClick(parentCategory, item.name, formatCardGridPosition(index, gridCols));
      this.navigateTo(item.link);
    },
    handleMenuSelect(option,index) {
      console.log('handleMenuSelect', option,this.navData);
      const { productId, menuType, productName } = this.productMenuState;
      const linksMap = menuType === 'product' ? this.navData.productMenuLinks : this.navData.solutionMenuLinks;
      const itemLinks = linksMap && linksMap[productId];
      const url = itemLinks && itemLinks[option];
      markHomePageEngaged();
      const parentLabel = this.navDataTitle?this.navDataTitle:'';
      trackCategoryCardClick(parentLabel, `${productName} - ${option}`, `悬浮菜单-第${index+1}行`);
      this.productMenuState = { ...this.productMenuState, isOpen: false };
      if (url) this.navigateTo(url);
    },
    navigateTo(url) {
      if (!url) return;
      if (url.startsWith('http')) {
        window.location.href = url;
      } else {
        this.$router.push(url).catch(() => {});
      }
    },
    getButtonClass(item) {
      if (item.disabled) return 'btn-product btn-product--disabled';
      return this.hoveredId === item.id ? 'btn-product btn-product--active' : 'btn-product';
    }
  }
};
</script>

<style lang="scss" scoped>
.category-navigation {
  width: 100%;
  padding: 32px 0;
}

.category-navigation__inner {
  max-width: 1600px;
  margin: 0 auto;
}

/* Featured */
.featured-section {
  margin-bottom: 32px;
}

.featured-card {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(to bottom right, #dbeafe, #eff6ff);
  border: 2px solid #bfdbfe;
  border-radius: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
    transform: translateY(-4px);
  }

  &__content {
    flex: 1;
    text-align: center;
  }

  &__title {
    font-weight: bold;
    color: #0f52ba;
    margin-bottom: 8px;
    font-size: 24px;
  }

  &__desc {
    font-size: 14px;
    color: #2c3e50;
    line-height: 1.5;
  }

  &__arrow {
    font-size: 20px;
    color: #0f52ba;
    opacity: 0;
    transition: opacity 0.2s;
    flex-shrink: 0;
  }

  &:hover &__arrow {
    opacity: 1;
  }
}

/* Grid */
.grid-two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

@media (max-width: 1024px) {
  .grid-two {
    grid-template-columns: 1fr;
  }
}

/* Card Module */
.card-module {
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 2px solid #e0e0e0;
  transition: all 0.3s;

  &--hover:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    transform: translateY(-4px);
  }

  &__header {
    text-align: center;
    margin-bottom: 24px;
  }

  &__title {
    font-size: 28px;
    font-weight: bold;
    color: #0f52ba;
    margin-bottom: 8px;
  }

  &__subtitle {
    font-size: 14px;
    color: #2c3e50;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

/* Buttons */
.btn-intro {
  width: 100%;
  background: #0f52ba;
  color: #fff;
  font-weight: bold;
  padding: 12px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(15, 82, 186, 0.3);

  i {
    transition: transform 0.2s ease;
  }

  &:hover {
    background: #1a5fc4;
    box-shadow: 0 4px 12px rgba(15, 82, 186, 0.4);

    i {
      transform: translateX(4px);
    }
  }
}

/* Accordion */
.accordion,.accordion1 {
  background: linear-gradient(to bottom right, #e6f2ff, #d1e7ff);
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #b9d6ff;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    text-align: left;
    cursor: pointer;
  }

  &__title {
    font-size: 18px;
    font-weight: bold;
    color: #0f52ba;

  }

  &__header:hover &__title::after {
    transform: translateX(4px);
  }

  &__summary {
    font-size: 14px;
    color: #333;
    margin-top: 8px;
  }

  &__body {
    margin-top: 16px;
  }

  &__title--clickable {
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #1a5fc4;
    }
  }
}

.accordion__title::after {
      content: '▸';
      margin-left: 8px;
      font-size: 14px;
      opacity: 0.8;
      transition: transform 0.2s ease;
      display: inline-block;
    }
.accordion__arrow {
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #1a5fc4;
  }
}

/* Button Grid */
.button-grid {
  display: grid;
  gap: 12px;

  &--1 {
    grid-template-columns: 1fr;
  }

  &--2 {
    grid-template-columns: 1fr 1fr;
  }

  &--3 {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.btn-product {
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: #b9d6ff;
  color: #0f52ba;
  transition: all 0.2s;

  &--active {
    background: #0f52ba;
    color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: scale(1.05);
  }

  &--disabled {
    background: rgba(156, 163, 175, 0.5);
    opacity: 0.7;
    cursor: not-allowed;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 10px,
        rgba(255, 255, 255, 0.2) 10px,
        rgba(255, 255, 255, 0.2) 20px
      );
    }
  }
}

/* Athena groups */
.athena-products {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.athena-group__title {
  font-size: 16px;
  font-weight: bold;
  color: #0f52ba;
  padding: 0 8px 8px;
  margin-bottom: 0;
}

/* Additional sections */
.additional-sections {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__item {
    display: contents;
  }
}

.btn-full {
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #b9d6ff;
  background: linear-gradient(to bottom right, #e6f2ff, #d1e7ff);
  color: #0f52ba;
  transition: all 0.2s;

  &--active {
    background: #0f52ba;
    color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.btn-disabled {
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 500;
  text-align: center;
  background: rgba(156, 163, 175, 0.5);
  opacity: 0.7;
  cursor: not-allowed;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 10px,
      rgba(100, 100, 100, 0.3) 10px,
      rgba(100, 100, 100, 0.3) 20px
    );
  }
}

/* Bottom buttons */
.bottom-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-gradient {
  width: 100%;
  background: linear-gradient(to right, #4a89dc, #0f52ba);
  color: #fff;
  font-weight: bold;
  padding: 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    background: linear-gradient(to right, #0f52ba, #1a5fc4);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }
}
</style>
